import {
    guid as getGuid, 
    isGuid as valueIsGuid,
    emptyGuid
} from '../guid';


export default {
    methods: {
        guid(){
            return getGuid();
        },
        isGuid(value){
            return valueIsGuid(value);
        },
        emptyGuid() {
            return emptyGuid;
        }
    }
};